import React from 'react';
import {connect, useDispatch} from 'react-redux';
import frontendUtils from '../../../utils/frontendUtils';
import useWindowWidth from '../../hook/useWindowWidth';
import {openMenu} from '../sidebar/reducer';

export default React.memo(
  connect(
    state => ({accountSummary: state.components.auth.accountSummary}),
    null
  )(function Logo({isPartner}) {
    const width = useWindowWidth();
    const dispatch = useDispatch();
    return (
      <div className="kt-header__brand">
        {width > 800 && width <= 1366 && (
          <div className="kt-margin-r-25 kt-margin-l-5 cursor-pointer">
            <i
              className="fa fa-bars"
              style={{fontSize: '30px'}}
              aria-hidden="true"
              onClick={() => dispatch(openMenu())}
            />
          </div>
        )}
        <div className="kt-header__brand-logo" style={{display: 'block'}}>
          {isPartner ? (
            <a
              href={frontendUtils.getPfHomeUrl('smb-partner-logo')}
              target="_self"
              rel="noreferrer noopener"
            >
              <img
                alt="logo"
                src={require('../../../assets/images/layout/partner_logo.png')}
                width="18%"
              />
            </a>
          ) : (
            <a
              href={frontendUtils.getPfHomeUrl('smb-logo')}
              target="_self"
              rel="noreferrer noopener"
            >
              <img
                alt="logo"
                src={require('../../../assets/images/layout/logo.jpg')}
                width="40%"
              />
            </a>
          )}
        </div>
      </div>
    );
  })
);
